import * as Yup from 'yup'
import { buildOfferRecipientsValidation } from './offerRecipientYupValidation'
import { missignFieldMessage } from './messagesContants'

const containerOfferRecipientMessages = {
  firstNameRequired: missignFieldMessage,
  lastNameRequired: missignFieldMessage,
  emailRequired: 'Please provide the email of your offer recipient. ',
  emailInvalid: 'Enter valid email.',
  duplicateEmail: 'Duplicate emails are not allowed.',
}

export const offerRecipientValidation = Yup.object().shape({
  offerRecipients: buildOfferRecipientsValidation(
    containerOfferRecipientMessages
  ),
})
